import { BarsArrowDownIcon, BarsArrowUpIcon } from '@heroicons/react/24/outline';
import { usePreferences, useUpdatePreferences } from '../../hooks/usePreferences';

export type CommentOrder = 'asc' | 'desc';

/**
 * MKS-514 — the user's comment-thread order, from `preferences.commentOrder`.
 * ABSENT (or `enabled: false`) means `asc`, the server's oldest-first order.
 * Pass `enabled: false` for portal users: they have no /auth/preferences.
 */
export function useCommentOrder(enabled: boolean): CommentOrder {
  const { data } = usePreferences({ enabled });
  return enabled && data?.commentOrder === 'desc' ? 'desc' : 'asc';
}

/** MKS-514 — the arrow next to the Comments heading that flips the order. */
export function CommentOrderToggle() {
  const order = useCommentOrder(true);
  const updatePreferences = useUpdatePreferences();
  const label =
    order === 'asc' ? 'Oldest first — switch to newest first' : 'Newest first — switch to oldest first';

  return (
    <button
      type="button"
      onClick={() => updatePreferences.mutate({ commentOrder: order === 'asc' ? 'desc' : 'asc' })}
      className="p-0.5 rounded text-ms-text-muted hover:text-ms-text-primary hover:bg-ms-canvas"
      aria-label={label}
      title={order === 'asc' ? 'Oldest first' : 'Newest first'}
    >
      {order === 'asc' ? (
        <BarsArrowDownIcon className="h-4 w-4" aria-hidden />
      ) : (
        <BarsArrowUpIcon className="h-4 w-4" aria-hidden />
      )}
    </button>
  );
}
